module.exports = __webpack_public_path__ + "media/images/placeholders/create_by_link-b56f090591d23ce3b15426f5511e7663.svg";